export class Group {
    Id:Number ;
    GroupName :String ;
    GroupLeaderName :String ;
    GroupAsstLeaderName :String ;
    CentreId :Number ;
    MaxMembers :Number ;
    Details :String ;
    EmployeeId :Number ;
    EmployeeBranchId :Number ;
    CompanyId :Number ;
    SaasId :Number ;
    IsActive  :Number;
    Flag : Number
}
